import React, { useEffect, useState } from "react";
const CollapsableCard = ({
  children,
  title,
  defaultOpen,
  classes,
  onChangeOpen,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (defaultOpen !== undefined) {
      setIsOpen(defaultOpen);
    }
  }, [defaultOpen]);

  function handleOpen() {
    setIsOpen(!isOpen);
    if (onChangeOpen) {
      onChangeOpen(!isOpen);
    }
  }
  return (
    <div className={`card ${classes}`} key={title}>
      <div className="card-header d-flex justify-content-between">
        <h4 className="card-title">{title}</h4>
        {
          //eslint-disable-next-line
          <a
            type="button"
            data-action="collapse"
            onClick={handleOpen}
            style={{ padding: "2px 6px" }}
          >
            {isOpen ? (
              <i className="feather icon-minus" />
            ) : (
              <i className="feather icon-plus" />
            )}
          </a>
        }
      </div>
      {isOpen && (
        <div className="collapse show" aria-expanded="true">
          <div className="card-body">{children}</div>
        </div>
      )}
    </div>
  );
};
export default CollapsableCard;
